import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import COLORS from '../../common/styles/color-pallete';
import CommonButton from '../common-button/CommonButton';
import { FONT_FAMILY } from '../../common/styles/fontStyles';

export const Modal = styled.div`
  position: absolute;
  height: 400vh;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  background-color: rgba(255, 255, 255, 0.8);

  .modalBox {
    position: absolute;
    margin-left: 20px;
    top: ${(props) => props.top};
    width: ${(props) => props.popupWidth};
    height: ${(props) => props.popupHeight};
    object-fit: contain;
    border-radius: 4px;
    box-shadow: 2px 2px 10px 0 rgba(0, 0, 0, 0.1);
    border: solid 1px #f7f7f7;
    background-color: ${COLORS.white};
    padding: 10px;

    .crossButton {
      font-size: 20px;
      color: ${COLORS.black};
      width: 100%;
      font-family: ${FONT_FAMILY.hellix.regular};
      display: flex;
      justify-content: flex-end;
      margin-right: 20px;
      margin-top: 19px;
      button {
        color: #00c1ff;
        background-color: white;
        border: none;
      }
    }

    .closeButton {
      width: 100%;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.67;
      letter-spacing: 0.64px;
      text-align: center;
      margin-top: 30px;
    }
  }
`;

const MobileModal = (props) => {
  const { componentBox, popupHeight, popupWidth, top } = props;

  const scrollWin = () => {
    window.scrollTo(props.scrollTop, 0);
  };

  const handleCloseModal = () => {
    props.closeModal();
    scrollWin();
  };

  return (
    <Modal popupHeight={popupHeight} popupWidth={popupWidth} top={top}>
      <div className="modalBox">
        <div className="crossButton">
          <button onClick={handleCloseModal}>X</button>
        </div>
        {componentBox || 'Add Your Component Box'}
        <CommonButton text="Close" type="link" onClick={handleCloseModal} className="closeButton" />
      </div>
    </Modal>
  );
};

MobileModal.propTypes = {
  componentBox: PropTypes.any,
  popupHeight: PropTypes.string,
  popupWidth: PropTypes.string,
  top: PropTypes.string,
  closeModal: PropTypes.func,
  scrollTop: PropTypes.number
};

export default MobileModal;
